import React from 'react';
import styled from 'styled-components';

export const Wrap = styled.div`
  background-color: white;

  @media (min-width: 1024px) {
    min-height: calc(100vh - 80px);
  }

  @media (min-width: 1366px) {
    min-height: calc(100vh - 70px);
  }
`;
